//
/* GS://PROTOCOLO
 * Arquivo: src/services/OrderService.js
 * Dossiê de Projeto e Manual de Colaboração: Ecossistema GoldenSisters
 * Versão: 2.1.0 – FEATURE: Cancelamento com Motivo (Service)
 * Impacto da Versão: [src/services/OrderService.js]
 * Data: 06/12/2025
 * Responsável: Gemini (conforme Protocolo)
 *
 * Mudanças desta versão:
 * - [NOVO]: Adicionado parâmetro `cancellationReason` à função `updateOrderStatus`.
 * - [PAYLOAD]: Envia o motivo para a Cloud Function se presente.
 */
//

import { getApp } from 'firebase/app'; 
import { getFunctions, httpsCallable } from 'firebase/functions';

// GS: Especifica a região correta para as Cloud Functions
const functions = getFunctions(getApp(), 'southamerica-east1');

/**
 * Chama a Cloud Function para alterar o status de um pedido.
 * @param {string} orderId - O ID do pedido a ser atualizado.
 * @param {string} newStatus - O novo status para o pedido.
 * @param {string|null} trackingCode - O código de rastreio, se o status for 'enviado'.
 * @param {string|null} cancellationReason - O motivo do cancelamento, se o status for 'cancelado'.
 * @returns {Promise<void>}
 * @throws {Error} Lança um erro se a chamada da função falhar.
 */
export const updateOrderStatus = async (orderId, newStatus, trackingCode = null, cancellationReason = null) => {
  try {
    const callable = httpsCallable(functions, 'updateOrderStatus');
    const data = {
      orderId,
      newStatus,
    };

    if (trackingCode) {
      data.trackingCode = trackingCode;
    }

    // [GS-CORRECAO-INICIO: Envia o motivo do cancelamento se houver]
    if (cancellationReason) {
      data.cancellationReason = cancellationReason;
    }
    // [GS-CORRECAO-FIM]

    await callable(data);
    console.log(`Pedido ${orderId} atualizado para ${newStatus} com sucesso.`);

  } catch (error) {
    console.error("Erro ao chamar a função 'updateOrderStatus': ", error);
    // Propaga o erro para que o componente de UI possa tratá-lo (ex: mostrar um alerta)
    throw new Error(error.message || 'Falha ao atualizar o status do pedido.');
  }
};